import { render, staticRenderFns } from "./OrderItemMediaDeleteForm.vue?vue&type=template&id=2b0f6f41"
import script from "./OrderItemMediaDeleteForm.vue?vue&type=script&lang=js"
export * from "./OrderItemMediaDeleteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports